import SimpleModal from '@modules/admin/common/modal/simpleModal'
import Button from '@modules/admin/common/button'
import { WrapNoData, WrapperButtonsBetween } from '@modules/admin/groups/styled'
import React from 'react'

export const RemoveModal = ({ hide, confirmFn, className, text, t, disabled = 0 }) => {
  return (
    <SimpleModal
      hideModal={hide}
      loading={false}
      className={className}
      template={
        <>
          {text}
          {!disabled && (
            <WrapperButtonsBetween>
              <Button className="buttonCancelDeleteContent" cancel onClick={hide}>
                {t('Cancelar')}
              </Button>
              <Button className="buttonConfirmDeleteContent" onClick={confirmFn}>
                {t('Confirmar')}
              </Button>
            </WrapperButtonsBetween>
          )}
        </>
      }
    />
  )
}

export const WarningModal = ({ text, closeFn }) => {
  return (
    <SimpleModal
      title="Warning"
      className="no-data-modal"
      hideModal={closeFn}
      loading={false}
      template={<WrapNoData>{text}</WrapNoData>}
    />
  )
}
